import React, { useState, useEffect } from "react";
import Home from "../Home/Home";
import Top from "../Top/Top";
import Matrix from "../Matrix/Matrix";
import Biography from '../Biography/Biography';
import Works from '../Works/Works';
import Service from '../Service/Service';
import Schedule from '../Schedule/Schedule';
import Sns from "../Sns/Sns";
import Note from "../Note/Note";
import Contact from '../Contact/Contact';
import Wipe from '../Wipe/Wipe';
import NotFound from '../NotFound/NotFound';
import './Main.css';




const Main = ({ activeScreen, setActiveScreen }) => {

    const [isAnimating, setIsAnimating] = useState(false);
    const [currentScreen, setCurrentScreen] = useState(activeScreen);
    const [hasRenderedOnce, setHasRenderedOnce] = useState(false);



    useEffect(() => {
        if (!hasRenderedOnce) {
            setHasRenderedOnce(true);
            return;
        }
        setIsAnimating(true);
        const animationTimeout = setTimeout(() => {
            setIsAnimating(false);
            setCurrentScreen(activeScreen);
        }, 3000);

        return () => clearTimeout(animationTimeout);

    }, [activeScreen])

    const renderScreen = () => {

        switch (currentScreen) {
            case "home":
                return <Home setActiveScreen={setActiveScreen} isFirstVisit={false} />;
            case "top":
                return <Top  setActiveScreen={setActiveScreen}/>;
            case "whatsnew":
                return <Matrix />;
            case "biography":
                return <Biography />;
            case "works":
                return <Works />;
            case "service":
                return <Service />;
            case "schedule":
                return <Schedule />;
            case "note":
                return <Note />;
            case "sns":
                return <Sns />;
            case "contact":
                return <Contact />;
            default:
                return <NotFound />

        }
    }

    return (

        <div style={{ position: "relative", overflow: "auto" }} className="Main__wrapper">
            <div style={{ position: "absolute", zIndex: 1 }} className="main__contents">{renderScreen()}</div>
            {isAnimating && <Wipe />}
        </div>
    )
}

export default Main;